import sliderLocationTeaser from '../../../../../../src24/js/modules/sliderLocationTeaser';

window.addEventListener('load', () => {
    sliderLocationTeaser.init();
});
